//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  IUploadQueueState,
  UploadQueueStatus,
} from '@media-library/redux/upload-queue/uploadQueueModel';
import { SliceNames } from '@redux/SliceNames';

const initialState: IUploadQueueState = {
  queuedItemIds: [],
  status: UploadQueueStatus.Idle,
};

const { actions, reducer } = createSlice({
  name: SliceNames.MediaUploadQueue,
  initialState,
  reducers: {
    addQueuedItem: (state, action: PayloadAction<{ itemId: string }>) => {
      state.queuedItemIds = [...state.queuedItemIds, action.payload.itemId];
      state.status = UploadQueueStatus.Uploading;
    },
    removeFailedItem: (state, action: PayloadAction<{ itemId: string }>) => {
      const { itemId } = action.payload;

      const updatedQueue = state.queuedItemIds.filter((id) => id !== itemId);
      state.queuedItemIds = updatedQueue;
      state.status = UploadQueueStatus.Failed;
    },
    removeUploadedItem: (state, action: PayloadAction<{ itemId: string }>) => {
      // Remove uploaded item from queue and set `status` to `Success`. Observers may refetch media items when `queuedItemIds` is updated and `status` is `Success` to add newly uploaded item to the list.
      const { itemId } = action.payload;

      const updatedQueue = state.queuedItemIds.filter((id) => id !== itemId);
      state.queuedItemIds = updatedQueue;
      state.status = UploadQueueStatus.Success;
    },
  },
});

export const UploadQueueActions = actions;
export const UploadQueueReducer = reducer;
